import { render, staticRenderFns } from "./crmSetting.vue?vue&type=template&id=30bdc78d&"
import script from "./crmSetting.vue?vue&type=script&lang=js&"
export * from "./crmSetting.vue?vue&type=script&lang=js&"
import style0 from "./crmSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30bdc78d')) {
      api.createRecord('30bdc78d', component.options)
    } else {
      api.reload('30bdc78d', component.options)
    }
    module.hot.accept("./crmSetting.vue?vue&type=template&id=30bdc78d&", function () {
      api.rerender('30bdc78d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/crmSetting.vue"
export default component.exports